import React from 'react';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import lightenDarkenColor from '@/lib/colors/lightenDarkenColor';
import Captions from '@/widget/ui/components/WidgetNavigator/Captions';
import ConversationStartButton from '@/widget/ui/components/WidgetNavigator/ConversationStartButton';
import LastConversations from '@/widget/ui/components/WidgetNavigator/LastConversations';
import useConversationsList from '@/widget/ui/hooks/useConversationsList';
import QuickLinks from '@/widget/ui/components/WidgetNavigator/QuickLinks';
import OperatorsList from '@/widget/ui/components/shared/OperatorsList';
import cx from 'classnames';
import Header from './Header';
import styles from './WidgetNavigator.module.scss';

function WidgetNavigator() {
  const { settings } = useChatWidgetContext();
  const {
    links, host, color, isMobile,
  } = settings;
  const gradientHelperColor = lightenDarkenColor(color, -0.38);
  const { conversations, openConversation } = useConversationsList();

  const style = {
    background: `linear-gradient(150deg, ${gradientHelperColor} 0%, ${color} 40%, #FFFFFF 100%)`,
  };

  return (
    <div className={cx(styles.container, { [styles.mobile]: isMobile })} style={style}>
      <Header />
      <div className={styles.content}>
        <div className={styles.operators}>
          <OperatorsList />
        </div>
        <div className={styles.captions}>
          <Captions />
        </div>
        <div className={styles.block}>
          <ConversationStartButton />
        </div>
        {!!conversations.length && (
          <div className={styles.block}>
            <LastConversations
              conversations={conversations}
              openConversation={openConversation}
            />
          </div>
        )}
        {!!links && !!links.length && (
          <div className={styles.block}>
            <QuickLinks links={links} host={host} color={color} />
          </div>
        )}
      </div>
    </div>
  );
}

export default WidgetNavigator;
